// const API_URL = process.env.NODE_ENV === "production" ? "https://api.dev.spokenlayer.net/web-player" : "http://localhost/"
const API_URLS = {
  production: "https://api.spokenlayer.net/web-player",
  development: "https://api.dev.spokenlayer.net/web-player",
  staging: "https://api.staging.spokenlayer.net/web-player",
}

const SNOWPLOW_COLLECTOR = process.env.REACT_APP_SNOWPLOW_COLLECTOR || "d.spokenlayer.com"

const SNOWPLOW_COLLECTORS = (process.env.NODE_ENV === "production")
  ? { production: SNOWPLOW_COLLECTOR }
  : { development: SNOWPLOW_COLLECTOR }

const API_URL = process.env.REACT_APP_API_URL || API_URLS[process.env.BUILD] || API_URLS.development

export default {
  API_URL,
  SNOWPLOW_COLLECTORS,
}



// WEBPACK FOOTER //
// ./src/config/index.js